import React, { FC, useEffect, useState } from 'react';
import { Box, BoxProps, Container } from '@hover/blueprint';
import { motion } from '@hover/blueprint/foundation';
import { transitions } from 'polished';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import NavbarDesktop from './Desktop';
import NavbarMobile from './Mobile';

export interface IPartnerNavbarProps {
  linksDesktop: INavbarItem[];
  linksMobile: INavbarItem[];
  navbarBackgroundColor: BoxProps['color'] | undefined;
  isNavbarWhite: boolean;
  titleColor?: string;
  logo: JSX.Element;
}

const Navbar: FC<IPartnerNavbarProps> = ({
  linksDesktop,
  linksMobile,
  isNavbarWhite,
  navbarBackgroundColor,
  titleColor,
  logo,
}) => {
  const [navbarScrolled, setNavbarScrolled] = useState(false);

  useEffect(() => {
    const scrollHandler = () => setNavbarScrolled(window.scrollY >= 110);
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  const navbarColor = navbarScrolled ? 'neutral.0' : navbarBackgroundColor;

  return (
    <Box
      maxW="100vw"
      w="100vw"
      bg={navbarColor}
      justifyContent="center"
      position="fixed"
      top={0}
      zIndex="dropdown"
      {...transitions(
        ['background', 'box-shadow', 'border'],
        motion.easings[250],
      )}
      shadow={navbarScrolled ? 'distance300' : 'invisibleNeutral'}
    >
      {/* for Branch journeys injected smart banner */}
      <div className="branch-journeys-top" style={{ display: 'none' }} />
      <Container maxW="100%" overflow="hidden" px={{ base: 0, desktop: 900 }}>
        <Box display={{ desktop: 'flex', base: 'none' }} width="100%">
          <NavbarDesktop
            titleColor={titleColor}
            links={linksDesktop}
            isNavbarWhite={isNavbarWhite || navbarScrolled}
            logo={logo}
          />
        </Box>
        <Box display={{ desktop: 'none', base: 'flex' }} width="100%">
          <NavbarMobile
            navbarColor={navbarColor}
            links={linksMobile}
            isNavbarWhite={isNavbarWhite || navbarScrolled}
            titleColor={titleColor}
            logo={logo}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Navbar;
